
<script>

import _ from 'lodash';
import Vue from 'vue';
import VueField from './vue-field.vue'
export default {

    props:{
        name:{
            required:true
        },
        value:{
            type:Object,
            default:()=>{}
        },
        fields:{
            type:Array
        },
        canvalidate:{
            default:true
        }
    },

    data(){
        return {
            values:{},
            errorFields:[],
        }
    },

    watch:{
        // value:function(newVal,oldVal){
        //     
        //     this.$forceUpdate();
        // }
    },

    created:function(){
       
       this.values = {...this.value}
        //set my fields to create the model
       if( !_.isEmpty(this.fields) ){
            this.myFields = this.fields
       }else{
            this.myFields = this.findVueFields(this.$slots.default)
       }
    },

    beforeUpdate(val1,val2) {
        // this.values = this.value

    },


    computed:{
        myFields:{
            set: function (newValue) {  
                
                var fields = {};
                var values = {};
                
                _.each(newValue, (v)=>{
                    if(v.name){
                        let vv = _.get(v,'value','');
                        if(_.has(this.values,v.name))
                              vv = this.values[v.name]
                        Vue.set(this.values,v.name,vv)
                        values[v.name] = vv
                    }
                })


                this.$store.commit('addForm',{ name:this.name, fields:newValue, values:values })


                this.$watch('values', function(newVal, oldVal){
                            var values = {};
                            _.each(newValue, (v)=>{
                                if(v.name){
                                    let vv = _.get(v,'value','');
                                    if(_.has(this.values,v.name))
                                        vv = this.values[v.name]
                                    Vue.set(this.values,v.name,vv)
                                    values[v.name] = vv
                                }
                            })
                          
                           this.$store.commit('updateForm',{name:this.name,fields:newValue,  values:values })
                           console.log("form-change %o",newVal)
                           this.$emit('change',newVal)
                           this.$emit('input',newVal)
                    
                    }, {
                     deep: true
                })
            },

            get: function () {
                return this.$store.getters.formFields(this.name);  
            }

        },
    },



    render:function(h){
    
      let self = this;    
      let fieldsNodes = [];
      let classeAditional= '';
    
      if(this.$slots['default']){
            fieldsNodes = [this.processVueFields(this.$slots.default, h) ];
      }
    

      if( !_.isEmpty(this.fields) ){    
           fieldsNodes = _.map(this.myFields, field =>{
                return h('vue-field', {...this.createFields(field),  class:'col-12 col-lg-6'} )
           })
           classeAditional = ' row '
       }

        return h('form',{
                    on: {
                        submit:function(event){
                            event.preventDefault()
                        }
                    }
                    },
                    [ h('div',{
                                staticClass:'v-form ' + classeAditional
                            },
                               fieldsNodes   
                        )
                    ]
            ) 
    },


    // updated:function(){
    //    if( !_.isEmpty(this.fields) ){
    //         this.myFields = this.fields
    //    }else{
    //         this.myFields = this.findVueFields(this.$slots.default)
    //    }
    // },

    methods:{

        createFields:function(field){
           let self=this;

           var inputFunc = function(){};
           var changeFunc = function(){};

           if(_.has(field,'on.input') ){
               inputFunc = field.on.input;
           }
           if(_.has(field,'on.change') ){
               changeFunc = field.on.change;
           }
         
           return {
                    props:{...field, formName:this.name, value: this.values[field.name] },
                    ref:'vuefields',
                    refInFor: true, 
                    // domProps: {
                    //     value: this.values[field.name]
                    // },
                    on: {
                        input: function (vv) {
                            
                            self.values[field.name] = vv
                            inputFunc.call(field.context,vv)
                        },
                        change: function (vv) {
                            
                             self.values[field.name] = vv
                             changeFunc.call(field.context,vv)
                        }
                    }
                }
        },
        

         findVueFields:function(VueNodes){
                let fieldsFound = [];
                function transverse(nodes){
                        if(_.isArray(nodes)){
                            for (let i = 0; i < nodes.length; i++) {
                                let vm = nodes[i];
                                transverse(vm)
                            }
                        }else if(_.isObject(nodes)) {
                            if( _.get(nodes,'componentOptions.tag',_.get(nodes,'tag'))==='vue-field'){
                                    var obj = {...nodes.data.attrs,...nodes.componentOptions.propsData}
                                    if (nodes.data.model){
                                        obj.value = nodes.data.model.value
                                        obj.modelKey = nodes.data.model.expression
                                    }
                                    fieldsFound.push(obj)
                            } else if(nodes.children){
                                    transverse(nodes.children)
                            }
                        }
                }
                transverse(VueNodes)
                return fieldsFound
         },


        processVueFields:function(VueNodes, h){
            let self = this;
            let fieldsFound = [];

            function transverse(nodes){
                let newNodes = [];
                if(_.isArray(nodes)){

                    for (let i = 0; i < nodes.length; i++) {
                        let vm = nodes[i];
                        vm = transverse(vm)[0]
                        newNodes.push(vm)
                    }

                }else if(_.isObject(nodes)) {
                    let vm = nodes
                    if( _.get(nodes,'componentOptions.tag',_.get(nodes,'tag'))==='vue-field'){
                            var obj = {...nodes.data.attrs,...nodes.componentOptions.propsData}
                            // 
                            if (nodes.data.model){
                                obj.value = nodes.data.model.value
                                obj.modelKey = nodes.data.model.expression
                            }

                            obj.on = vm.componentOptions.listeners;

                            // vm.componentOptions.listeners.input = function(){
                            //       self.values[obj.name] = val
                            // }

                            // input: function (val) {
                            //     self.values[obj.name] = val
                            // },
                            // change: function (val) {
                            //     self.values[obj.name] = val
                            // }

                            vm = h('vue-field', {...self.createFields(obj),class:_.get(vm.data,'staticClass')} )
                    }

                    else if(nodes.children){
                        vm.children = transverse(nodes.children)
                    }

                    newNodes.push(vm)

                }

                return newNodes
            }

           let newNodesFinal = transverse(VueNodes)
           return  newNodesFinal;

        },

        registeForm:function(){
            this.$store.form
        },

        hasError:async function(){
            if(this.canvalidate == false){
                return false;
            }
            let error = false;
            //mak each of my vue-fields to validate
            for(let i = 0; i< this.$refs.vuefields.length; i++){
                  let vuefield = this.$refs.vuefields[i]
                  var res = await vuefield.runValidations();
                  console.log("resp formfiels.runValidations %o", res)
                  if(res === false){
                      error = true
                  }
            }
            
            return error;
            //check my own validations
        },
        getValues:function(){
            return this.values
        }

    }

}
</script>

<style>

</style>
